import React from 'react';
import PropTypes from 'prop-types';
import Skeleton from '@mui/material/Skeleton';
import { StyledStack } from './styles';

const VpTableSkeleton = ({ rows = 10, rowHeight = 54.5, headHeight = 38.3, ...rest }) => {
  const rowSkeletons = Array(rows).fill(true);
  return (
    <StyledStack {...rest}>
      <Skeleton height={headHeight} />
      {rowSkeletons?.map((e, index) => (
        <Skeleton height={rowHeight} key={index} />
      ))}
      <Skeleton height={58} sx={{ marginTop: '10px' }} />
    </StyledStack>
  );
};

VpTableSkeleton.propTypes = {
  rows: PropTypes.number,
  rowHeight: PropTypes.number,
  headHeight: PropTypes.number
};

export default VpTableSkeleton;



// WEBPACK FOOTER //
// ./src/vp-ui/widgets/VpTableSkeleton/VpTableSkeleton.jsx